module.exports = __webpack_public_path__ + "img/other_oppo3.daa39a2b.jpg";